import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useStateContext } from "../contexts/ContextProvider";
import Footer from "../components/Footer/Footer";
import ContestIntro from "../components/ContestIntro/ContestIntro";

export default function ContestIntroduction() {
  const { contestId } = useParams();
  const { loading, contests, getAllContests } = useStateContext();
  let homeContest = contests.filter((c) => c._id === contestId)[0];

  useEffect(() => {
    getAllContests();
  }, []);

  if (loading || contests.length === 0)
    return <p className="text-center bg-blue-600 text-white">Loading...</p>;

  return (
    <>
      <div className="text-white min-w-full z-0">
        <div className="mb-12">
          <ContestIntro contest={homeContest} />
        </div>
      </div>
      <Footer />
    </>
  );
}
